import { useRef } from "react";
import { Search } from "lucide-react";
import Input from "./Input";

interface Props {
  delay?: number;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
}

export default function SearchInput({
  delay = 500,
  onChange,
  onSearch,
}: Props) {
  const timeOutRef = useRef<NodeJS.Timeout>(null);

  const onChangeValue = (value: string) => {
    onChange?.(value);
    if (timeOutRef.current) clearTimeout(timeOutRef.current);
    timeOutRef.current = setTimeout(async () => {
      onSearch?.(value);
    }, delay);
  };

  return (
    <div className="relative flex h-8 items-center">
      <Input
        type="text"
        placeholder="Search"
        onChange={(e) => onChangeValue(e.target.value)}
      />
      <div className="absolute right-2">
        <Search size={18} />
      </div>
    </div>
  );
}
